import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PrismAssessmentState {
  private _canAccessAssessment = false;

  public setCanAccessAssessment(value: boolean): void {
    this._canAccessAssessment = value;
  }

  public getCanAccessAssessment(): boolean {
    return this._canAccessAssessment;
  }
}

export const PrismAssessmentGuard: CanActivateFn = () => {
  const router = inject(Router);
  const state = inject(PrismAssessmentState);

  if (state.getCanAccessAssessment()) {
    return true;
  } else {
    void router.navigate(['/']);
    return false;
  }
};
